$(document).ready(function(){
  $('#recently-viewed-products').slick({
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 2,
    dots: false,
    arrows: true,
    prevArrow: '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></div>',
    nextArrow: '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></div>',
    adaptiveHeight: true,
    swipe: true,
    touchMove: true,
    touchThreshold: 10,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }
    ]
  });

  $(".recently_view_block .prev").click(function (e) {
    e.preventDefault();
    $("#recently-viewed-products").slick("slickPrev");
  });

  $(".recently_view_block .next").click(function (e) {
    e.preventDefault();
    $("#recently-viewed-products").slick("slickNext");
  });
});
